import { render, staticRenderFns } from "./CommunicationModal.vue?vue&type=template&id=274e9e4c&scoped=true"
import script from "./CommunicationModal.vue?vue&type=script&lang=js"
export * from "./CommunicationModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicationModal.vue?vue&type=style&index=0&id=274e9e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e9e4c",
  null
  
)

export default component.exports